import React from 'react';
import { ArrowLeftIcon, FileTextIcon } from 'lucide-react';
export function TermsOfService() {
  return <div className="min-h-screen bg-white" data-id="element-382">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100 px-4 py-4" data-id="element-383">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-384">
          <a href="#/" className="text-2xl font-bold text-[#1B2A4A] tracking-tight" data-id="element-385">
            Bevo Coastal <span className="text-[#E8913A]" data-id="element-386">Investments</span>
          </a>
          <a href="#/" className="inline-flex items-center text-[#1B2A4A] font-medium hover:text-[#E8913A] transition-colors text-sm" data-id="element-387">
            <ArrowLeftIcon className="w-4 h-4 mr-1.5" data-id="element-388" />
            Back to Home
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-id="element-389">
        <div className="flex items-center gap-3 mb-8" data-id="element-390">
          <div className="w-10 h-10 bg-[#E8913A]/10 rounded-lg flex items-center justify-center" data-id="element-391">
            <FileTextIcon className="w-5 h-5 text-[#E8913A]" data-id="element-392" />
          </div>
          <div data-id="element-393">
            <h1 className="text-3xl md:text-4xl font-extrabold text-[#1B2A4A]" data-id="element-394">
              Terms of Service
            </h1>
            <p className="text-slate-500 text-sm mt-1" data-id="element-395">
              Last updated: March 1, 2026
            </p>
          </div>
        </div>

        <div className="prose prose-slate max-w-none space-y-8" data-id="element-396">
          <section data-id="element-397">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-398">
              1. Acceptance of Terms
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-399">
              By accessing and using bevocoastalinvestments.com ("the Website"),
              you agree to be bound by these Terms of Service. If you do not
              agree to these terms, please do not use our Website or services.
            </p>
          </section>

          <section data-id="element-400">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-401">
              2. Description of Services
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-402">
              Bevo Coastal Investments LLC provides a platform for homeowners to
              request cash offers for their residential properties. We are a
              licensed real estate investment company operating in the state of
              Florida. Our services include property evaluation, cash offer
              presentation, and facilitation of real estate transactions.
            </p>
          </section>

          <section data-id="element-403">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-404">
              3. No Obligation
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-405">
              Submitting your information through our Website does not create
              any obligation to sell your property. Any cash offer we present is
              non-binding until a formal purchase agreement is signed by both
              parties. You are free to accept or decline any offer at your sole
              discretion.
            </p>
          </section>

          <section data-id="element-406">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-407">
              4. Accuracy of Information
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-408">
              You agree to provide accurate and complete information when using
              our forms and services. Providing false or misleading information
              may result in an inaccurate offer or termination of the
              transaction process. We reserve the right to verify all
              information provided and adjust our offer accordingly.
            </p>
          </section>

          <section data-id="element-409">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-410">
              5. Offer Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-3" data-id="element-411">
              Cash offers presented by Bevo Coastal Investments are:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-412">
              <li data-id="element-413">
                Based on our evaluation of the property's condition, location,
                and current market conditions
              </li>
              <li data-id="element-414">
                Subject to change based on property inspection or discovery of
                undisclosed conditions
              </li>
              <li data-id="element-415">
                Valid for a limited time as specified in the offer communication
              </li>
              <li data-id="element-416">
                Not a guarantee of purchase until a formal agreement is executed
              </li>
            </ul>
          </section>

          <section data-id="element-417">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-418">
              6. No Fees or Commissions
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-419">
              Bevo Coastal Investments does not charge sellers any fees,
              commissions, or closing costs. We cover all standard closing costs
              associated with the transaction. There are no hidden charges at
              any point in the process.
            </p>
          </section>

          <section data-id="element-420">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-421">
              7. Limitation of Liability
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-422">
              Bevo Coastal Investments and its affiliates shall not be liable
              for any indirect, incidental, special, or consequential damages
              arising from the use of our Website or services. Our total
              liability shall not exceed the amount of any offer made. We are
              not responsible for delays caused by third parties, including
              title companies, lenders, or government agencies.
            </p>
          </section>

          <section data-id="element-423">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-424">
              8. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-425">
              All content on this Website, including text, graphics, logos, and
              design elements, is the property of Bevo Coastal Investments and
              is protected by applicable intellectual property laws. You may not
              reproduce, distribute, or create derivative works without our
              written permission.
            </p>
          </section>

          <section data-id="element-426">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-427">
              9. Governing Law
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-428">
              These Terms of Service shall be governed by and construed in
              accordance with the laws of the State of Florida. Any disputes
              arising from these terms or your use of our services shall be
              resolved in the courts of Pinellas County, Florida.
            </p>
          </section>

          <section data-id="element-429">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-430">
              10. Changes to Terms
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-431">
              We reserve the right to modify these Terms of Service at any time.
              Changes will be posted on this page with an updated effective
              date. Continued use of the Website after changes are posted
              constitutes acceptance of the revised terms.
            </p>
          </section>

          <section data-id="element-432">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-433">
              11. Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-434">
              If you have any questions about these Terms of Service, please
              contact us:
            </p>
            <div className="mt-3 text-slate-600" data-id="element-435">
              <p data-id="element-436">Bevo Coastal Investments LLC</p>
              <p data-id="element-437">7901 4th Street N, Ste 300</p>
              <p data-id="element-438">St. Petersburg, FL 33702</p>
              <p data-id="element-439">
                Email:{' '}
                <a href="mailto:Info@bevocoastalinvestments.com" className="text-[#E8913A] hover:underline" data-id="element-440">
                  Info@bevocoastalinvestments.com
                </a>
              </p>
              <p data-id="element-441">
                Phone:{' '}
                <a href="tel:8883417570" className="text-[#E8913A] hover:underline" data-id="element-442">
                  (888) 341-7570
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>
    </div>;
}